export enum FIELD_NAMES {
  NAME = "name",
  EMAIL = "email",
  QUESTION = "question",
  URGENCY = "urgency",
}

export const URGENCY_OPTIONS = [
  { value: 'high', label: 'High' },
  { value: 'low', label: 'Low' },
]